import { render, staticRenderFns } from "./TemplateSelectWidget.vue?vue&type=template&id=05326694&"
import script from "./TemplateSelectWidget.vue?vue&type=script&lang=js&"
export * from "./TemplateSelectWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports